import { render, staticRenderFns } from "./MobileDeviceFrame.vue?vue&type=template&id=215a1362&scoped=true&"
import script from "./MobileDeviceFrame.vue?vue&type=script&lang=js&"
export * from "./MobileDeviceFrame.vue?vue&type=script&lang=js&"
import style0 from "./MobileDeviceFrame.vue?vue&type=style&index=0&id=215a1362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a1362",
  null
  
)

export default component.exports